'use strict';

angular.module('app', [
    // Third party modules
    'ui.router',
    'ui.bootstrap',

    'js-data',
    'ngAnimate',
    'ngTouch',
    'ngSanitize',
    'hm.readmore',
    'duScroll',
    'color.picker',
    //'720kb.socialshare',
    'angulartics',
    'angulartics.google.analytics',

    'templates',
    'header',
    'dashboard',
    'programme',
    'login',
    'forgot',
    'footer',
    'listUtils',
    'userSettings',
    'btorfs.multiselect',

    // In house modules
    'ngKomondor',
    'ngKomondorEditor',
    'ngKomondorMediaLibrary',
    'ngKomondorAccess',

    'admin',
    'admin.user',
    'admin.programme',
    'admin.category',
    'admin.article',
    'admin.article-page',
    'admin.template',
    'admin.language',
    'admin.season',
    'admin.video',
    'admin.iframe',
])

.config(function ($locationProvider)
{
    $locationProvider
        .html5Mode(true)
        .hashPrefix('!');
})

/**
 * Set the default state after login
 */
.config(function (kdLoginProvider)
{
    kdLoginProvider.setAfterLoginState('admin.programmes');
})

.config(function ($provide)
{
    $provide.decorator('kdLogin', function ($delegate, kdAuth, DS) {

        //Removed DS.clear();
        $delegate.onLoginSuccess = function (user)
        {
            user = DS.inject('User', user);
            kdAuth.setUser(user);

            return user;
        };

        return $delegate;
    });
})

.constant('roles', {
    admin: 1,
})

/**
 * Define the printer gate
 */
.config(function (kdGateProvider, roles)
{

    kdGateProvider.before(function (user)
    {
        if (user && user.role_id === roles.admin) {
            return true;
        }
    });

    kdGateProvider.define('user', function (user) {
        return !!user;
    });

    kdGateProvider.define('admin', function (user) {
        if (user) {
            return user.role_id === roles.admin;
        }

        return false;
    });
})

.config(function (DSProvider)
{
    DSProvider.defaults.basePath = '/api/';
})

/**
 * Create the require parent states
 */
.config(function ($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.otherwise('/');

    $stateProvider
        .state('app', {
            abstract: true,
            views: {
                header: {
                    templateUrl: 'modules/header/header.html',
                    controller: 'HeaderCtrl'
                },
                footer: {
                    templateUrl: 'modules/footer/footer.html',
                    controller: 'FooterCtrl'
                },
                '': {
                    template: '<div class="container-full-width"><ui-view></ui-view></div>'
                }
            },
            resolve: {

            }
        });

    $stateProvider
        .state('guest', {
            abstract: true,
            views: {
                header: {
                    templateUrl: 'modules/header/header.html',
                    controller: 'HeaderCtrl'
                },
                footer: {
                    templateUrl: 'modules/footer/footer.html',
                    controller: 'FooterCtrl'
                },
                '': {
                    template: '<div class="container-full-width"><ui-view></ui-view></div>'
                }
            }
        });
})

/**
 * Scroll to top when state changed.
 */
.run(function ($rootScope, $location, $window, $document)
{
    $rootScope.$on('$stateChangeSuccess', function() {
        $document[0].body.scrollTop = 0;
        $document[0].documentElement.scrollTop = 0;
    });
})

/**
 * Registration is disabled. Block the register page (provided by the
 * ng-komondor-access 'guest.register' state at /register) and send users
 * to the login page instead.
 */
.run(function ($rootScope, $state)
{
    $rootScope.$on('$stateChangeStart', function ($event, state)
    {
        if (state.name === 'guest.register') {
            $event.preventDefault();
            $state.go('guest.login');
        }
    });
})

// google analytics GA4
// .run(function ($rootScope, $location, $window, $document) {
//     $window.dataLayer = $window.dataLayer || [];
//     function gtag(){$window.dataLayer.push(arguments);}
    
//     $rootScope.$on('$stateChangeSuccess', function(){
//         gtag('event', 'page_view', {
//             page_title: $document[0].title,
//             page_location: $location.host(),
//             page_path: $location.path(),
//             send_page_view: true
//         });
//     });
// })

/**
 * iOS Safari implements neither the standard nor the vendor-prefixed
 * Fullscreen API, so Fullscreen.enable() (which only checks
 * requestFullScreen/webkitRequestFullscreen/etc.) silently no-ops there and
 * the video-player's fullscreen button does nothing on iPhone. iOS only
 * exposes fullscreen for <video> through the proprietary
 * webkitEnterFullscreen() method, so fall back to it when none of the
 * standard APIs are available.
 */
.config(function ($provide)
{
    $provide.decorator('Fullscreen', function ($delegate)
    {
        var originalEnable = $delegate.enable;

        $delegate.enable = function (element)
        {
            var hasStandardApi = element.requestFullScreen ||
                element.mozRequestFullScreen ||
                element.webkitRequestFullscreen ||
                element.msRequestFullscreen;

            if (!hasStandardApi && element.tagName === 'VIDEO' &&
                typeof element.webkitEnterFullscreen === 'function') {
                element.webkitEnterFullscreen();
                return;
            }

            originalEnable(element);
        };

        return $delegate;
    });
})

/**
 * Override videogular video template to enable inline playback on iOS.
 */
.run(function ($templateCache)
{
    $templateCache.put('vg-templates/vg-media-video',
        '<video playsinline webkit-playsinline></video>'
    );
})

/**
 * Override video-player template to add native poster attribute for iOS.
 * iOS Safari does not preload video or show first frame, so without a native
 * poster attribute the video area appears blank before the user taps play.
 */
.run(function ($templateCache)
{
    $templateCache.put('ng-komondor-editor/scripts/components/video-player/video-player.html',
        '<div class="video-player">' +
            '<img class="video-poster"' +
                ' ng-src="{{ computed.thumbSafe }}"' +
                ' ng-class="{\'video-placeholder\':!data.asset_id || forcePoster }"' +
                ' ng-if="state.editMode ? true: data.asset_id">' +
            '<video height="100%"' +
                   ' width="100%"' +
                   ' preload' +
                   ' controls' +
                   ' playsinline' +
                   ' ng-attr-poster="{{ computed.thumbSafe }}"' +
                   ' ng-attr-controlsList="{{data.hideDownloads === true ? \'nodownload\' : \'\'}}"' +
                   ' disable-right-click="{{data.hideDownloads}}"' +
                   ' ng-class="{\'fullscreen\': data.fullSize}"' +
                   ' ng-style="{ \'opacity\' : forcePoster ? \'0\' : \'1\' }">' +
                '<source ng-src="{{ computed.links.mp4 }}" type="video/mp4" ng-if="computed.links.mp4 && !forcePoster">' +
                '<source ng-src="{{ computed.links.webm }}" type="video/webm" ng-if="!computed.links.mp4 && computed.links.webm && !forcePoster">' +
                'Your browser does not support the video tag.' +
            '</video>' +
            '<div ng-if="!ctrl.options.nativeControls" video-player-controls state="playback"></div>' +
            '<p class="caption" ng-if="data.hasCaption" editable ng-model="data.caption" ng-trim="false"></p>' +
        '</div>'
    );
})

/**
 * Show state errors
 */
.run(function ($rootScope, $log)
{
    $rootScope.$on('$stateChangeError',
    function (event, toState, toParams, fromState, fromParams, error) {
        $log.debug('state change error');
        throw error;
    });
});
